export default __webpack_public_path__ + "static/media/PTAC-Full Logo-Stacked_resized.88076215.png";